import { mbSize, Media } from '@foxrenderfarm/common'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 210px;
  background: linear-gradient(100deg, #ffe6d5 0%, #ffd7bc 27%, #ffefe5 86%, #fbf9f6 105%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 110px;
  ${Media.lessThan(Media.small)} {
    height: ${mbSize(320)};
    padding-top: ${mbSize(180)};
  }
`
